import React, { useState, useEffect } from "react";
import { BsChevronRight } from "react-icons/bs";
import ChatbotImage from "./../assets/chatbot.png";
import { PRIMARY_COLOR, TERTIARY_COLOR, TEXT_COLOR } from "../constants/theme";
import { toast } from "react-toastify";
import {
  createNewChat,
  getChatbotChat,
  getChatbotMessagesPaginated,
  sendChatBotMessage,
} from "../services/chatbot/chatbot.service";
import moment from "moment/moment";
import Loader from "../components/Loader";
import { getPatientbyID } from "../services/patient/patient.service";
import { Avatar } from "@mui/material";
import Config from "../services/config";

const ChatbotScreen = () => {
  const email = sessionStorage.getItem("email");
  const patientId = sessionStorage.getItem("patientId");
  const companyCode = sessionStorage.getItem("companyCode");
  const distributorCode = sessionStorage.getItem("distributorCode")
    ? JSON.parse(sessionStorage.getItem("distributorCode"))[0]?.distributor_code
    : "";
  const clinicCode = sessionStorage.getItem("clinicCode")
    ? JSON.parse(sessionStorage.getItem("clinicCode"))[0]?.clinic_code
    : "";
  const [screenWidth, setScreenWidth] = useState(0);
  const [chat, setChat] = useState({});
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [profileData, setProfileData] = useState({});

  const resizeWindow = () => {
    setScreenWidth(window?.outerWidth);
  };

  const getPatientData = async () => {
    try {
      const response = await getPatientbyID(email, patientId);

      if (response.status === 200) {
        setProfileData(response?.data?.data);
      } else {
        return;
      }
    } catch (error) {
      console.log("ERROR FETCHING PATIENT DATA => ", error);
      return;
    }
  };

  const getChatAndMessages = async () => {
    try {
      setLoading(true);
      const response = await getChatbotChat(email, clinicCode, patientId);
      if (response.data.status === 201) {
        const newChat = await createNewChat(
          email,
          distributorCode,
          clinicCode,
          patientId,
          companyCode,
          moment().format("YYYY-MM-DD"),
          new Date().getTime(),
          "",
          0,
          true,
          false,
          "",
          "",
          "",
          "",
          ""
        );
        if (newChat.data.status === 200) {
          setChat(newChat.data.data);
          setMessages([]);
          setLoading(false);
        } else {
          setChat({});
          setMessages([]);
          setLoading(false);
        }
      }
      if (response.data.status === 200) {
        setChat(response.data.data);
        const messageResponse = await getChatbotMessagesPaginated(
          email,
          response.data.data.chat_id,
          pageNumber
        );
        if (messageResponse.data.status === 200) {
          let temp =
            messageResponse.data.data && messageResponse.data.data.length > 0
              ? messageResponse?.data.data
              : [];
          temp = temp.sort((a, b) => a.time - b.time);
          setMessages(temp);
          setPageNumber(messageResponse.data.page_info.page);
          setTotalPages(messageResponse.data.page_info.totalPages);
        } else {
          setMessages([]);
          setPageNumber(0);
          setTotalPages(0);
        }
        setLoading(false);
      }
    } catch (error) {
      console.log("ERROR while getting ai chat / messages ", error);
      // toast.error(error.message || error.data.message);
      setLoading(false);
    }
  };

  const getOlderMessages = async () => {
    setLoading(true);
    try {
      const tempMessages = [...messages];
      const messageResponse = await getChatbotMessagesPaginated(
        email,
        chat.chat_id,
        pageNumber
      );
      if (messageResponse.data.status === 200) {
        tempMessages.unshift(
          ...messageResponse.data.data.sort((a, b) => a.time - b.time)
        );
        setMessages(tempMessages);
        setPageNumber(messageResponse.data.page_info.page);
        setTotalPages(messageResponse.data.page_info.totalPages);
        setLoading(false);
      } else {
        setMessages([]);
        setPageNumber(0);
        setTotalPages(0);
        setLoading(false);
      }
    } catch (error) {
      console.log("Error fetching messages => ", error);
      // toast.error(error.message || error.data.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  useEffect(() => {
    getPatientData();
    getChatAndMessages();
  }, []);

  useEffect(() => {
    if (pageNumber && pageNumber > 1) {
      getOlderMessages();
    }
  }, [pageNumber]);

  const handleSendMessage = async () => {
    if (!message || message?.trim() === "") {
      return;
    }
    try {
      setLoading(true);
      const messageResponse = await sendChatBotMessage(
        email,
        chat.chat_id,
        distributorCode,
        clinicCode,
        companyCode,
        patientId,
        moment().format("YYYY-MM-DD"),
        true,
        patientId,
        "smilebot@yopmail.com",
        message,
        "",
        new Date().getTime(),
        moment().format("YYYY-MM-DD"),
        email,
        "smilebot@yopmail.com",
        "",
        "",
        false,
        "",
        true,
        email,
        new Date().getTime()
      );
      if (messageResponse.status === 200) {
        setPageNumber(0);
        setTotalPages(0);
        setMessage("");
        getChatAndMessages();
      }
    } catch (error) {
      console.log("Error sending message!", error);
      toast.error("Error sending message!");
      setLoading(false);
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      if (message && message !== "") {
        handleSendMessage();
      }
    }
  };

  return (
    <div
      className="position-relative"
      style={{
        minHeight: "100vh",
        zIndex: "20",
        padding: "2px 15px 10px 15px",
      }}
    >
      <div
        className="row w-100 mx-auto flex-column align-items-center justify-content-start"
        style={{
          backgroundColor: "rgb(255, 255, 255)",
          padding: "13px 13px 20px 13px",
          borderRadius: "18px",
          gap: "15px",
          //   minHeight: "calc(100vh - 80px)",
        }}
      >
        <div
          className="row w-100 mx-auto align-items-center justify-content-start"
          style={{
            padding: "12px 4px 12px 10px",
            backgroundColor: "rgb(203, 108, 230)",
            borderRadius: "16px",
            gap: "14px",
            cursor: "pointer",
          }}
        >
          <div className="col-auto p-0">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                height: "50px",
                width: "50px",
              }}
            >
              <img
                className="w-100"
                src={ChatbotImage}
                alt="aligner"
                style={{}}
              />
            </div>
          </div>
          <div className="col p-0">
            <div
              className="d-flex flex-column justify-content-center"
              style={{
                fontSize: "17.5px",
                color: "#ffffff",
                gap: "3px",
                lineHeight: "1",
              }}
            >
              <div className="" style={{}}>
                SmileBot
              </div>
              <div
                className=""
                style={{
                  fontSize: "10px",
                  lineHeight: "1.25",
                }}
              >
                AI Assistant
              </div>
            </div>
          </div>
        </div>

        {/* MESSAGES */}

        <div
          className="row w-100 mx-auto flex-column align-items-center justify-content-start flex-nowrap p-0"
          style={{
            gap: "20px",
            minHeight: "calc(-248px + 100vh)",
            maxHeight: "calc(-248px + 100vh)",
            overflowY: "scroll",
            scrollBehavior: "smooth",
            scrollbarWidth: "none",
            paddingBottom: "20px",
          }}
        >
          {loading && <Loader />}
          {!loading && (!messages || messages.length === 0) && (
            <div>
              <center>
                <p>
                  No messages. Send a message to get responses from our AI
                  assistant.
                </p>
              </center>
            </div>
          )}
          {!loading && totalPages !== pageNumber && (
            <div className="d-flex flex-row justify-content-center">
              <button
                className="btn"
                style={{
                  backgroundColor: PRIMARY_COLOR,
                  color: TERTIARY_COLOR,
                }}
                onClick={(e) => setPageNumber(pageNumber + 1)}
              >
                Older messages!
              </button>
            </div>
          )}
          {messages &&
            messages.length > 0 &&
            messages.map((item) => {
              if (item.sender_id === patientId) {
                return (
                  <div
                    className="row w-100 mx-auto flex-row-reverse align-items-start justify-content-start"
                    style={{
                      gap: "10px",
                    }}
                  >
                    <div className="col-auto p-0">
                      <div
                        className=""
                        style={{
                          width: "35px",
                          height: "35px",
                          borderRadius: "50%",
                          backgroundImage:
                            "linear-gradient(270deg, rgba(203,108,230,1) 0%, rgba(203,108,230,0.7) 80%, rgba(250,229,255,1) 100%)",
                        }}
                      >
                        <Avatar
                          alt="Profile"
                          src={
                            profileData.profile_picture
                              ? `${
                                  Config.filePath + profileData.profile_picture
                                }`
                              : ""
                          }
                        />
                      </div>
                    </div>

                    <div className="col p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-end justify-content-start"
                        style={{
                          gap: "5px",
                        }}
                      >
                        <div
                          className="col-auto"
                          style={{
                            paddingInlineEnd: "0",
                            paddingInlineStart: "45px",
                          }}
                        >
                          <div
                            className="text-end"
                            style={{
                              fontSize: "12px",
                              color: TERTIARY_COLOR,
                              backgroundColor: PRIMARY_COLOR,
                              // borderTopRightRadius: "15px",
                              // borderBottomLeftRadius: "15px",
                              // borderTopLeftRadius: "15px",
                              borderRadius: "15px",
                              padding: "12px 11px 14px 10px",
                              // maxWidth: screenWidth >= 576 ? "305px" : "100%",
                              width: "100%",
                            }}
                          >
                            {item.message_content}
                          </div>
                        </div>
                        <div className="col-auto p-0">
                          <div
                            className="text-end"
                            style={{
                              fontSize: "9px",
                              color: TEXT_COLOR,
                              lineHeight: "1",
                            }}
                          >
                            {moment(item.time).format("hh:mm A")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div
                    className="row w-100 mx-auto align-items-start justify-content-start"
                    style={{
                      gap: "10px",
                    }}
                  >
                    <div className="col-auto p-0">
                      <div
                        className=""
                        style={{
                          width: "35px",
                          height: "35px",
                          borderRadius: "50%",
                          backgroundImage:
                            "linear-gradient(270deg, rgba(67, 160, 239, 1) 0%, rgba(67, 160, 239, 0.6) 80%, rgba(250,229,255,1) 100%)",
                          padding: "4px",
                        }}
                      >
                        <img
                          className="w-100 h-100"
                          src={ChatbotImage}
                          alt="avatar1"
                          style={{
                            maxWidth: "100%",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>

                    <div className="col p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-start justify-content-start"
                        style={{
                          gap: "5px",
                        }}
                      >
                        <div
                          className="col-auto"
                          style={{
                            paddingInlineStart: "0",
                            paddingInlineEnd: "45px",
                          }}
                        >
                          <div
                            className="text-start"
                            style={{
                              fontSize: "12px",
                              color: "white",
                              // color: "rgb(0, 49, 255)",
                              backgroundColor: "rgba(0, 49, 255,0.5)",
                              // backgroundColor: "rgb(159, 202, 239)",
                              // borderTopRightRadius: "15px",
                              // borderBottomRightRadius: "15px",
                              // borderTopLeftRadius: "15px",
                              borderRadius: "15px",
                              padding: "12px 10px 14px 11px",
                              // maxWidth: screenWidth >= 576 ? "305px" : "100%",
                            }}
                          >
                            {item?.message_content}
                          </div>
                        </div>
                        <div className="col-auto p-0">
                          <div
                            className="text-start"
                            style={{
                              fontSize: "9px",
                              color: TEXT_COLOR,
                              lineHeight: "1",
                            }}
                          >
                            {moment(item.time).format("hh:mm A")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
        </div>

        <div
          className="row w-100 mx-auto align-items-center justify-content-center flex-nowrap"
          style={{
            backgroundColor: PRIMARY_COLOR,
            border: `1px solid ${PRIMARY_COLOR}`,
            borderRadius: "25px",
            padding: "4px 8px",
            gap: "5px",
          }}
        >
          <div className="col p-0">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                height: "100%",
                backgroundColor: "#ffffff",
                borderRadius: "25px",
                padding: "8px 10px",
              }}
            >
              <input
                disabled={loading}
                className="w-100 text-center chatbot-input"
                type="text"
                placeholder="Ask me anything related to orthodontics"
                style={{
                  fontSize: "12px",
                  border: "none",
                  outline: "none",
                  background: "none",
                  width: "100%",
                  // padding: '5px',
                  lineHeight: "1",
                  color: TEXT_COLOR,
                }}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={(e) => handleEnter(e)}
              />
            </div>
          </div>

          <div className="col-auto p-0">
            <button
              disabled={loading}
              className="btn chatbot-btn d-flex align-items-center justify-content-center"
              style={{
                // backgroundColor: PRIMARY_COLOR,
                height: "28px",
                width: "28px",
                padding: "2px 1px 2px 3px",
                borderRadius: "50%",
                border: "none",
              }}
              onClick={() => handleSendMessage()}
            >
              <BsChevronRight
                style={{
                  height: "100%",
                  width: "100%",
                  overflow: "visible",
                  color: TERTIARY_COLOR,
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotScreen;
